var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.currentComponent + 'Component',{tag:"component",attrs:{"id":_vm.id},on:{"on-reloadRight":_vm.reloadRight,"update:id":function($event){_vm.id=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }